import { type FileAsset, FileType, type GlobalSearchResultItem } from 'models';
import { useTranslation } from 'react-i18next';

import { FileIconDeprecated } from 'ui';
import { SearchItemContent } from '../search-item-content';
import { SearchItemRow } from '../search-item-row';

type P = {
  itemActionProps?: Record<string, unknown>;
  itemProps: GlobalSearchResultItem;
};

const FileItem = ({ itemActionProps, itemProps }: P) => {
  const { t } = useTranslation();

  return (
    <SearchItemRow itemActionProps={itemActionProps}>
      {/* eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- TODO: fix later */}
      <FileIconDeprecated asset={{ contentType: itemProps.file?.contentType ?? '', type: FileType } as FileAsset} />
      <SearchItemContent
        subtitle={t('fileSearchItemDate', {
          date: itemProps.createdAt,
          fileName: `, ${itemProps.file?.contentType.split('/')[1]?.toUpperCase() ?? ''}`,
        })}
        title={itemProps.name ?? ''}
      />
    </SearchItemRow>
  );
};

export default FileItem;
